import React from "react";

import { TermsAndConditionsContent } from "../../../components/TermsAndConditionsContent";

import "./Content.module.scss";

export const Content = () => {
  return (
    <div className="terms-and-conditions">
      <div className="u-flexCenter u-justifyContentCenter">
        <div className="u-maxWidth600">
          <TermsAndConditionsContent />
        </div>
      </div>
    </div>
  );
};
